"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initializeSegment = exports.SegmentMock = exports.SegmentLive = void 0;

require("core-js/modules/es6.array.slice.js");

require("regenerator-runtime/runtime.js");

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _merge2 = _interopRequireDefault(require("lodash/merge"));

var _isPlainObject2 = _interopRequireDefault(require("lodash/isPlainObject"));

var _analyticsNext = require("@segment/analytics-next");

var _appConfig = _interopRequireDefault(require("@nerdwallet/app-config"));

var _utils = require("./utils");

// eslint-disable-next-line max-classes-per-file
var SegmentLive = /*#__PURE__*/function () {
  function SegmentLive(analytics) {
    (0, _classCallCheck2.default)(this, SegmentLive);
    this.analytics = analytics;
  } // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types


  (0, _createClass2.default)(SegmentLive, [{
    key: "segmentInstance",
    get: function get() {
      return this.analytics;
    } // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types

  }, {
    key: "page",
    value: function () {
      var _page = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this$analytics;

        var _args = arguments;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                (_this$analytics = this.analytics).page.apply(_this$analytics, _args);

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function page() {
        return _page.apply(this, arguments);
      }

      return page;
    }() // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types

  }, {
    key: "track",
    value: function () {
      var _track = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _this$analytics2;

        var _len,
            args,
            _key,
            event,
            properties,
            newArgs,
            _args2 = arguments;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                for (_len = _args2.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                  args[_key] = _args2[_key];
                }

                event = args[0], properties = args[1];
                newArgs = args.slice(2); // Inject deployable info into the event properties

                if ((0, _isPlainObject2.default)(event)) {
                  event = (0, _merge2.default)({}, {
                    properties: (0, _utils.getDeployableInfo)()
                  }, event);
                } else {
                  properties = (0, _merge2.default)({}, (0, _utils.getDeployableInfo)(), properties);
                }

                (_this$analytics2 = this.analytics).track.apply(_this$analytics2, [event, properties].concat((0, _toConsumableArray2.default)(newArgs)));

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function track() {
        return _track.apply(this, arguments);
      }

      return track;
    }()
  }, {
    key: "trackLink",
    value: function () {
      var _trackLink = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var _len2,
            args,
            _key2,
            elem,
            event,
            properties,
            _args3 = arguments;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                for (_len2 = _args3.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                  args[_key2] = _args3[_key2];
                }

                elem = args[0], event = args[1];
                properties = args[2]; // Inject deployable info into the event properties

                if ((0, _isPlainObject2.default)(properties)) {
                  properties = (0, _merge2.default)({}, (0, _utils.getDeployableInfo)(), properties);
                }

                this.analytics.trackLink(elem, event, properties);

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function trackLink() {
        return _trackLink.apply(this, arguments);
      }

      return trackLink;
    }()
  }]);
  return SegmentLive;
}();

exports.SegmentLive = SegmentLive;

var SegmentMock = /*#__PURE__*/function () {
  function SegmentMock() {
    (0, _classCallCheck2.default)(this, SegmentMock);
  }

  (0, _createClass2.default)(SegmentMock, [{
    key: "page",
    value: // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, class-methods-use-this
    function () {
      var _page2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var _console;

        var _len3,
            args,
            _key3,
            _args4 = arguments;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                for (_len3 = _args4.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
                  args[_key3] = _args4[_key3];
                }

                (_console = console).log.apply(_console, ['ANALYTICS PAGE_VIEW'].concat(args));

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function page() {
        return _page2.apply(this, arguments);
      }

      return page;
    }() // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, class-methods-use-this

  }, {
    key: "track",
    value: function () {
      var _track2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var _console2;

        var _len4,
            args,
            _key4,
            _args5 = arguments;

        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                for (_len4 = _args5.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
                  args[_key4] = _args5[_key4];
                }

                (_console2 = console).log.apply(_console2, ['ANALYTICS TRACK'].concat(args));

              case 2:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      function track() {
        return _track2.apply(this, arguments);
      }

      return track;
    }() // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, class-methods-use-this

  }, {
    key: "trackLink",
    value: function () {
      var _trackLink2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var _console3;

        var _len5,
            args,
            _key5,
            _args6 = arguments;

        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                for (_len5 = _args6.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
                  args[_key5] = _args6[_key5];
                }

                (_console3 = console).log.apply(_console3, ['ANALYTICS TRACK LINK'].concat(args));

              case 2:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      function trackLink() {
        return _trackLink2.apply(this, arguments);
      }

      return trackLink;
    }()
  }]);
  return SegmentMock;
}();

exports.SegmentMock = SegmentMock;

var initializeSegment = function initializeSegment() {
  var _config$SEGMENT;

  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$debug = _ref.debug,
      debug = _ref$debug === void 0 ? false : _ref$debug;

  if (debug) {
    return new SegmentMock();
  }

  var writeKey = _appConfig.default === null || _appConfig.default === void 0 ? void 0 : (_config$SEGMENT = _appConfig.default.SEGMENT) === null || _config$SEGMENT === void 0 ? void 0 : _config$SEGMENT.WRITE_KEY;

  if (!writeKey || typeof window === 'undefined') {
    return new SegmentMock();
  }

  var browserAnalytics = _analyticsNext.AnalyticsBrowser.load({
    writeKey: writeKey,
    cdnURL: 'https://siteusagetools.nerdwallet.com'
  }, {
    integrations: {
      'Segment.io': {
        apiHost: 'siteusage.nerdwallet.com/v1',
        protocol: 'https'
      }
    }
  });

  return new SegmentLive(browserAnalytics);
};

exports.initializeSegment = initializeSegment;